import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@breath-lab/state';
import { ROUTES } from '@app/routes';
import { getNavItems } from './navItems';
import styles from './Sidebar.module.css';

function DesignSystemIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="13.5" cy="6.5" r="2.5" />
      <circle cx="19" cy="14" r="2.5" />
      <circle cx="6.5" cy="14.5" r="2.5" />
      <path d="M13.5 9v3m0 0l-5 3m5-3l4.5 2.5" />
    </svg>
  );
}

export default function Sidebar() {
  const { user, firebaseUser } = useAuth();
  const { t } = useTranslation('nav');

  const displayName = user?.displayName ?? firebaseUser?.displayName ?? firebaseUser?.email?.split('@')[0] ?? 'User';
  const initial = displayName[0]?.toUpperCase() ?? '?';
  const navItems = getNavItems(t).filter(({ to }) => to !== ROUTES.pricing);

  return (
    <aside className={styles.sidebar}>
      <NavLink to={ROUTES.loggedInHome} className={styles.brand}>
        <img src="/logo.svg" alt={t('brand')} className={styles.logo} />
        {t('brand')}
      </NavLink>

      <nav className={styles.nav}>
        <ul className={styles.links}>
          {navItems.map(({ to, label, icon, end }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) => `${styles.link} ${isActive ? styles.activeLink : ''}`}
              >
                <span className={styles.icon}>{icon}</span>
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {import.meta.env.DEV && (
        <NavLink
          to={ROUTES.designSystem}
          className={({ isActive }) => `${styles.devLink} ${isActive ? styles.devLinkActive : ''}`}
        >
          <span className={styles.icon}><DesignSystemIcon /></span>
          {t('designSystem')}
        </NavLink>
      )}

      <NavLink to={ROUTES.profile} className={styles.userSection}>
        <div className={styles.avatar} aria-hidden="true">{initial}</div>
        <span className={styles.userName}>{displayName}</span>
      </NavLink>
    </aside>
  );
}
